__turbopack_context__.v({
  "className": "poppins_4319474f-module__oVX1Cq__className",
});
